import http from "../http";
import { MainResponse } from "../../interfaces/api/response";
import api from "../../config/api";

/**
 * Service for fetching configuration data from the API
 */
const subscribe = {
  /**
   * Fetches configuration data from the API
   * @returns {Promise<ConfigResponse>} A Promise that resolves to the config response
   */
  subscribeUser: (body: {
    email: string;
    recaptchaToken: string;
  }): Promise<MainResponse> =>
    new Promise((resolve, reject) => {
      http
        .post(api.subscribe, body)
        .then((res) => resolve(res as MainResponse))
        .catch((e) => reject(e));
    }),
};

export default subscribe;
